import { create } from 'zustand';

interface GameStore {
  isPrivateCompetition: boolean;
  setIsPrivateCompetition: (isPrivateCompetition: boolean) => void;
}

export const useGameStore = create<GameStore>((set) => ({
  isPrivateCompetition: false,
  setIsPrivateCompetition: (isPrivateCompetition) =>
    set({ isPrivateCompetition }),
}));
